var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
var RequestOverviewComponent = /** @class */ (function () {
    function RequestOverviewComponent() {
        this.tagAddedEmitter = new EventEmitter();
        this.tagRemovedEmitter = new EventEmitter();
        this.autoCompleteItems = Input('autoCompleteItems');
        this.items = Input('items');
        this.selectedTags = Input('selectedTags');
        this.viewModel = {
            tableHeaders: {
                assigned: 'Assigned',
                research: 'Research',
                input: 'Input',
                comparison: 'Comparison',
                approval: 'Approval',
                amend: 'Amend',
                live: 'Live'
            }
        };
    }
    RequestOverviewComponent.prototype.tagAdded = function (tag) {
        this.tagAddedEmitter.emit(tag.value);
    };
    RequestOverviewComponent.prototype.tagRemoved = function (tag) {
        this.tagRemovedEmitter.emit(tag.value);
    };
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], RequestOverviewComponent.prototype, "tagAddedEmitter", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], RequestOverviewComponent.prototype, "tagRemovedEmitter", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], RequestOverviewComponent.prototype, "autoCompleteItems", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], RequestOverviewComponent.prototype, "items", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], RequestOverviewComponent.prototype, "selectedTags", void 0);
    RequestOverviewComponent = __decorate([
        Component({
            selector: 'request-overview',
            template: require('./request-overview.component.html'),
            styles: [require('./request-overview.component.scss')]
        }),
        __metadata("design:paramtypes", [])
    ], RequestOverviewComponent);
    return RequestOverviewComponent;
}());
export { RequestOverviewComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC1vdmVydmlldy5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJyZXF1ZXN0LW92ZXJ2aWV3LmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsWUFBWSxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBV3ZFO0lBU0k7UUFSaUIsb0JBQWUsR0FBeUIsSUFBSSxZQUFZLEVBQVUsQ0FBQztRQUNuRSxzQkFBaUIsR0FBeUIsSUFBSSxZQUFZLEVBQVUsQ0FBQztRQVFsRixJQUFJLENBQUMsaUJBQWlCLEdBQUcsS0FBSyxDQUFDLG1CQUFtQixDQUFDLENBQUM7UUFDcEQsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUM7UUFDNUIsSUFBSSxDQUFDLFlBQVksR0FBRyxLQUFLLENBQUMsY0FBYyxDQUFDLENBQUM7UUFDMUMsSUFBSSxDQUFDLFNBQVMsR0FBRztZQUNiLFlBQVksRUFBRTtnQkFDVixRQUFRLEVBQUUsVUFBVTtnQkFDcEIsUUFBUSxFQUFFLFVBQVU7Z0JBQ3BCLEtBQUssRUFBRSxPQUFPO2dCQUNkLFVBQVUsRUFBRSxZQUFZO2dCQUN4QixRQUFRLEVBQUUsVUFBVTtnQkFDcEIsS0FBSyxFQUFFLE9BQU87Z0JBQ2QsSUFBSSxFQUFFLE1BQU07YUFDZjtTQUNKLENBQUM7SUFDTixDQUFDO0lBRU0sMkNBQVEsR0FBZixVQUFnQixHQUFhO1FBQ3pCLElBQUksQ0FBQyxlQUFlLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUN6QyxDQUFDO0lBRU0sNkNBQVUsR0FBakIsVUFBa0IsR0FBYTtRQUMzQixJQUFJLENBQUMsaUJBQWlCLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUMzQyxDQUFDO0lBL0JTO1FBQVQsTUFBTSxFQUFFO2tDQUF5QixZQUFZO3FFQUFzQztJQUMxRTtRQUFULE1BQU0sRUFBRTtrQ0FBMkIsWUFBWTt1RUFBc0M7SUFDN0U7UUFBUixLQUFLLEVBQUU7O3VFQUFzQztJQUNyQztRQUFSLEtBQUssRUFBRTs7MkRBQXlDO0lBQ3hDO1FBQVIsS0FBSyxFQUFFOztrRUFBaUM7SUFMaEMsd0JBQXdCO1FBTHBDLFNBQVMsQ0FBQztZQUNQLFFBQVEsRUFBRSxrQkFBa0I7WUFDNUIsUUFBUSxFQUFFLE9BQU8sQ0FBQyxtQ0FBbUMsQ0FBQztZQUN0RCxNQUFNLEVBQUUsQ0FBQyxPQUFPLENBQUMsbUNBQW1DLENBQUMsQ0FBQztTQUN6RCxDQUFDOztPQUNXLHdCQUF3QixDQWlDcEM7SUFBRCwrQkFBQztDQUFBLEFBakNELElBaUNDO1NBakNZLHdCQUF3QiJ9